import ResponseErrorHandling from "../../../../helper/ResponseErrorHandling";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes } from "../../../action-types";

export const getClientKYCLink = (clientId = null) => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const url = clientId
      ? `/client/client-kyc-link?client_id=${clientId}`
      : `/client/client-kyc-link`;
    const res = await commonService.get(url);

    return res.data;
  } catch (err) {
    const message = err.response?.data?.message || err.message || err.toString();

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
    return err.response?.data;
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
